import { connect } from 'react-redux';
import { bindActionCreators, Dispatch, Action } from 'redux';

import { StateType } from 'types';
import { updateAngelInvestorMemberById } from 'redux/actions/people';
import { selectMemberDetails } from 'redux/selectors/angelInvestorMembers';
import { selectNationalities } from 'redux/selectors/workspace';
import { getNationalities } from 'redux/actions/workspace';
import { selectMyProfileId, selectUserType } from 'redux/selectors/auth';
import { getMyProfileData } from 'redux/actions/auth';
import { getAngelInvestorMemberById, getPartnerById } from 'redux/actions/angelInvestorMemberDetails';

const mapStateToProps = (state: StateType) => ({
  selectedMember: selectMemberDetails(state),
  nationalities: selectNationalities(state),
  userType: selectUserType(state),
  profileId: selectMyProfileId(state),
});

const mapDispatchToProps = (dispatch: Dispatch<Action>) => ({
  actions: bindActionCreators({
    getAngelInvestorMemberById,
    updateAngelInvestorMemberById,
    getPartnerById,
    getNationalities,
    getMyProfileData,
  }, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps);
